/* SHARED VARS */
var touch = false,
    clickEv = 'click',
    header_top = jQuery('#header').offset().top;

// Sniff a mobile browser
function isMobile() {
  var deviceAgent = navigator.userAgent.toLowerCase();

  if( Modernizr.touch || 
     (deviceAgent.match(/(iphone|ipod|ipad)/) ||
      deviceAgent.match(/(android)/)  || 
      deviceAgent.match(/(iemobile)/) || 
      deviceAgent.match(/iphone/i) || 
      deviceAgent.match(/ipad/i) || 
      deviceAgent.match(/ipod/i) || 
      deviceAgent.match(/blackberry/i) || 
      deviceAgent.match(/bada/i) ||
      deviceAgent.match(/windows phone/i) ||
      deviceAgent.match(/webOS/i))
    ){
    return true;
  }
  else {
    return false;
  }
}

/* Fucntion get width browser */
function getWidthBrowser() {
	var myWidth;

	if( typeof( window.innerWidth ) == 'number' ) { 
		//Non-IE 
		myWidth = window.innerWidth;
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myWidth = document.documentElement.clientWidth; 
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myWidth = document.body.clientWidth; 
	}
	
	return myWidth;
}

/* Fucntion get height browser */
function getHeightBrowser() {
	var myHeight;

	if( typeof( window.innerHeight ) == 'number' ) { 
		//Non-IE 
		myHeight = window.innerHeight; 
	} 
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
		//IE 6+ in 'standards compliant mode' 
		myHeight = document.documentElement.clientHeight;
	} 
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
		//IE 4 compatible 
		myHeight = document.body.clientHeight;
	}
	
	return myHeight;
}

// Handle Go to Page
function goToPage(){
  $('.action_page').click(function(e){
    var n = $(this).parent(),
        v = $('.go_page', n).val();

    Shopify.queryParams.page = v;
    location.search = $.param(Shopify.queryParams);
  });
  $('.go_page').on('keypress', function (event) {
    if(event.which == '13'){
      var v = $(this).val();

      Shopify.queryParams.page = v;
      location.search = $.param(Shopify.queryParams);
    }
  });
}

/* handle animate */
function handleDataAnimate(){
  
  if(touch == false){
    $('.animated').each(function(){

      var $toAnimateElement = $(this);

      var toAnimateDelay = $(this).attr('data-animation-delay');

      var toAnimateDelayTime = 0;

      if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }

      if( !$toAnimateElement.hasClass('visible') ) {

        var elementAnimation = $toAnimateElement.attr('data-animation');

        $toAnimateElement.appear(function () {

          setTimeout(function() {
            $toAnimateElement.addClass( elementAnimation + ' visible');
          }, toAnimateDelayTime);

        },{accX: 0, accY: -30},'easeInCubic'); 
      }
    });
  }
}

/* Handle Focus */
function handleFocus(){
  $(".form-focus input").focus(function() {
    $(this).parents('.form-focus').addClass('focus');
  }).blur(function() {
    $(this).parents('.form-focus').removeClass('focus');
  });
}

/* Handle Login Box */
function handleBoxLogin(){
  $("#loginBox input").focus(function() {
    $(this).parents('#loginBox').addClass('focus');
  }).blur(function() {
    $(this).parents('#loginBox').removeClass('focus');
  });
}

/* Handle dropdown */
function handleDropdown(){  
  $('.dropdown-link').on('click', function() {
     if(touch == false && getWidthBrowser() > 980 ){
       var href = $(this).attr('href');
       window.location = href;
     }
  });
  handleBoxLogin();
  handleFocus();
}


/* Handle scroll to top */
function handleScrollToTop() {
  
  function totop_button(a) {
    var b = $("#scroll-top");
    b.removeClass("off on");
    if (a == "on") { b.addClass("on") } else { b.addClass("off") }
  }
  
  $(window).scroll(function() {
    var b = $(this).scrollTop();
    var c = $(this).height();
    if (b > 0) { 
      var d = b + c / 2;
    } 
    else { 
      var d = 1 ;
    }
    
    if (d < 1e3) { 
      totop_button("off");
    } 
    else { 
      totop_button("on"); 
    }
  });
  
  $("#scroll-top").click(function (e) {
    e.preventDefault();
    $('html,body').animate({scrollTop:0},800,'swing');
  });
}


/* Handle screenshot to preview */
function handleScreenshotPreview(){
  /* CONFIG */
  var xOffset = 100;
  var yOffset = 50;
  /* END CONFIG */
  
  $(".screenshot").hover(function(e){
    
    $("body").append("<p id='screenshot'><span></span><img src='"+ $(this).attr('data-rel') +"' alt='' /></p>");
    
    if($(this).hasClass('odd')){
      $("#screenshot")
      .css("top",(e.pageY - xOffset) + "px")
      .css("right",(e.pageX + yOffset) + "px")
      .fadeIn("fast");
    }
    else if($(this).hasClass('even')){
      $("#screenshot")
      .css("top",(e.pageY - xOffset) + "px")
      .css("left",(e.pageX + yOffset) + "px")
      .fadeIn("fast");
    }
    
  },function(){
    
    $("#screenshot").remove();
  });
  
  $(".screenshot").mousemove(function(e){
    if($(this).hasClass('odd')){
      $("#screenshot")
      .css("top",(e.pageY - xOffset) + "px")
      .css("right",(e.pageX + yOffset) + "px");
    }
    else if($(this).hasClass('even')){
      $("#screenshot")
      .css("top",(e.pageY - xOffset) + "px")
      .css("left",(e.pageX + yOffset) + "px");
    }
      });	
}


/* Function: Refresh Zoom in */
function alwaysRefreshZoom(){
  if(touch == false){
    
    if($('.elevatezoom').length){
      
      var zoomImage = $('.elevatezoom .img-zoom');

      zoomImage.elevateZoom({
        gallery:'gallery_main', 
        galleryActiveClass: 'active', 
        zoomType: 'window',
        cursor: 'pointer',
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: false,
        easing : true,
        loadingIcon: '//cdn.shopify.com/s/files/1/2673/2824/t/3/assets/loader.gif?v=147071982126738704471514298455'
      });
      
      
        //pass the images to Fancybox
        $(".elevatezoom .img-zoom").bind("click", function(e) {  
          var ez =   $('.elevatezoom .img-zoom').data('elevateZoom');	
          $.fancybox(ez.getGalleryList(),{
            closeBtn  : false,
            helpers : {
              buttons	: {}
            }
          });
          return false;
        });
      
    }
    
  }
}

/* Function handle scroll product thumbs */
function handleImageThumbs(){
  if($('#gallery_main').length){
    
    if(touch){
      $('#product-image .main-image').on('click', function() {
        var _items = [];
        var _index = 0;
        var product_images = $('#product-image .image-thumb');
        product_images.each(function(key, val) {
          _items.push({'href' : val.href, 'title' : val.title});
          if($(this).hasClass('active')){
            _index = key;
          }
        });
        $.fancybox(_items,{
          closeBtn: false,
          index: _index,
          openEffect: 'none',
          closeEffect: 'none',
          nextEffect: 'none',
          prevEffect: 'none',
          helpers: {
            buttons: {}
          }
        });
        return false;
      });
    }
    else{
      
    }
       
    $('#product-image').on('click', '.image-thumb', function() {
      
      var $this = $(this);
      
      if(!$this.hasClass('active')){
        var parent = $this.parents('.product-image-wrapper');
        var src_original = $this.attr('data-image-zoom');
        var src_display = $this.attr('data-image');
        
        parent.find('.image-thumb').removeClass('active');
        $this.addClass('active');
        
        parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
        parent.find('.main-image').find('img').attr('src', src_display).load(function() {
          // to do
        });
      }
      
      return false;
    });
  }
}

/* Function: Refresh Zoom in Quick Shop */
function alwaysRefreshZoomQS(){
  if(touch == false){
    
    if($('.elevatezoom_qs').length){
      
      var zoomImage = $('.elevatezoom_qs .img-zoom');
      
      // Reinitialize EZ
      zoomImage.elevateZoom({
        gallery:'gallery_main_qs', 
        galleryActiveClass: 'active', 
        zoomType: 'window',
        cursor: 'pointer',
        zoomWindowFadeIn: 300,
        zoomWindowFadeOut: 300,
        scrollZoom: false,
        easing : true,
        loadingIcon: '//cdn.shopify.com/s/files/1/2673/2824/t/3/assets/loader.gif?v=147071982126738704471514298455'
      });
      
      
        //pass the images to Fancybox
        $(".elevatezoom_qs .img-zoom").bind("click", function(e) {  
          var ez =   $('.elevatezoom_qs .img-zoom').data('elevateZoom');	
          $.fancybox(ez.getGalleryList(),{
            closeBtn  : false,
            helpers : {
              buttons	: {}
            }
          });
          return false;
        });
      
    }
    
  }
}
      
/* Function update scroll product thumbs quickshop */
function alwaysScrollThumbsQS(){
  if($('#gallery_main_qs').length){

    $('#quick-shop-image').on(clickEv, '.image-thumb', function() {

      var $this = $(this);
      var parent = $this.parents('.product-image-wrapper');
      var src_original = $this.attr('data-image-zoom');
      var src_display = $this.attr('data-image');
      
      parent.find('.image-thumb').removeClass('active');
      $this.addClass('active');
      
      parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
      parent.find('.main-image').find('img').attr('src', src_display).load(function() {
        // to do
      });
      
      return false;
    });
  }
}

 
/* Handle Tooltip */
function handleTooltip(){
  if($('.btooltip').length){
    $('.btooltip').tooltip();
  }
}

/* Handle Tabs */
function handleTabs(){
  $('body').on('click', '.nav-tabs a', function (e) {
    e.preventDefault();
    $(this).tab('show');
  });
}
      
// Returns a random integer between min and max
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function mockupCaptionVideo(){
  if($('#home-video').length){
    if(getWidthBrowser() < 1200){
      var g_size = 13;
      var h_size = 60;
      var c_size = 30;
      var w_width = getWidthBrowser();

      var ch_size = h_size * w_width / 1200;
      var cc_size = c_size * w_width / 1200;

      if(ch_size < g_size) ch_size = g_size;
      if(cc_size < g_size) cc_size = g_size;

      $('#home-video .video_caption').css({'font-size': cc_size });
      $('#home-video .video_heading').css({'font-size': ch_size });
    }
    else{
      var h_size = 60;
      var c_size = 30;

      $('#home-video .video_caption').css({'font-size': c_size });
      $('#home-video .video_heading').css({'font-size': h_size });
    }

    var height = $('#home-video').height() / 2;
    var h = $('#home-video .video_width').height();
    var t = height - h/2;
    $('#home-video .video_width').css({'top': t, 'opacity': 1});
  }
}

function mockupCaptionSlider(){
  if($('#home-slider').length){

    if(getWidthBrowser() < 1200){
      var g_size = 13;
      var h_size = 60;
      var c_size = 30;
      var w_width = getWidthBrowser();

      var ch_size = h_size * w_width / 1200;
      var cc_size = c_size * w_width / 1200;

      if(ch_size < g_size) ch_size = g_size;
      if(cc_size < g_size) cc_size = g_size;

      $('#home-slider .slide-body > .caption').css({'font-size': cc_size });
      $('#home-slider .slide-body > .caption > h2').css({'font-size': ch_size });
      
      $('#home-slider .cameraContent > .camera_caption').css({'font-size': cc_size });
      $('#home-slider .cameraContent > .camera_caption .header').css({'font-size': ch_size });
    }
    else{
      var h_size = 60;
      var c_size = 30;

      $('#home-slider .slide-body > .caption').css({'font-size': c_size });
      $('#home-slider .slide-body > .caption > h2').css({'font-size': h_size });
      
      $('#home-slider .cameraContent > .camera_caption').css({'font-size': c_size });
      $('#home-slider .cameraContent > .camera_caption .header').css({'font-size': h_size });
    }

    var height = $('#home-slider').height() / 2;
    $('#home-slider .slide-body > .caption').each(function() {
      var h = $(this).height();
      var t = height - h/2;
      $(this).css({'top': t, 'opacity': 1});
    });
    
    var height = $('#home-camera-slider').height() / 2;
    $('#home-slider .cameraContent').each(function() {
      var d = $(this).find('>.camera_caption');
      $(this).show();
      var h = d.height();
      $(this).hide();
      var t = height - h/2;
      d.css({'top': t});
    });
  }
}
      
/* Handle Main Slideshow */
function handleSlideshow(){  
  if($('#home-slider').length){    
    
    // Callback FlexSlider
    $('#home-slider').flexslider({
      animation: "fade",
      prevText: "",
      nextText: "",
      slideshowSpeed: 3000,
      slideshow: true,
      controlNav: false,
      start: function(slider){
        $('body').removeClass('loading');
      }
    });
    imagesLoaded('#home-slider', function() {
      $('#home-slider-overlay').hide();
      mockupCaptionSlider();
    });
    
  }
}
      
/* Handle Map with GMap */
function handleMap(){
  if($('#contact_map').length){
    if(jQuery().gMap){
      $('#contact_map').gMap({
        zoom: 17,
        scrollwheel: false,
        maptype: 'ROADMAP',
        markers:[
          {
            address: '227 Nguyễn Văn Cừ, phường 4, Ho Chi Minh City, Vietnam',
            html: '_address',
            icon: {
              image: '//cdn.shopify.com/s/files/1/2673/2824/t/3/assets/icon-gmap.png?v=100304179082153305821514298452',
              iconsize: [188, 68],
              iconanchor: [0,68]
            }
          }
        ]
      });
    }
  }
}
      
/* Handle Grid List */
function handleGridList(){
  $('.grid_list span').click(function() {
    if(!$(this).hasClass('active')){
      $('.grid_list span').removeClass('active');
      $(this).addClass('active');
      
      if($(this).hasClass('grid')){
        $('#sandBox').removeClass('full_width');
      }
      else{
        $('#sandBox').addClass('full_width');
      }
    }
  });
}
      
/* Handle Menu when scroll */
function handleMenuScroll(){
  var scrollTop = $(this).scrollTop();
  var heightHeader = $('#header').outerHeight();

  if(touch == false && getWidthBrowser() >= 1024){
    if(scrollTop > heightHeader){
      if(!$('#header').hasClass('on')){
        
        if(!$('body').hasClass('templateIndex')){
          $('<div style="min-height:'+heightHeader+'px"></div>').insertBefore('#header');
        }
        
        
        $('#header').addClass('on');
        
      }
    }
    else{
      if($('#header').hasClass('on')){
        
        if(!$('body').hasClass('templateIndex')){
          $('#header').prev().remove();
        }
        
        
        $('#header').removeClass('on');
        
      }
    }
  }
}
    
/* Handle reset: Menu when scroll */
function handleResetMenuScroll(){

  if(touch == false){
    if(getWidthBrowser() < 1024){
      if($('#header').hasClass('on')){

        if(!$('body').hasClass('templateIndex')){
          $('#header').prev().remove();
        }

        
        $('#header').removeClass('on');
        
      }
    }
    else{
      var scrollTop = $(this).scrollTop();
      var heightHeader = $('#header').outerHeight();
      if(scrollTop > heightHeader){
        if(!$('#header').hasClass('on')){

          if(!$('body').hasClass('templateIndex')){
            $('<div style="min-height:'+heightHeader+'px"></div>').insertBefore('#header');
          }

          
          $('#header').addClass('on');
          
        }
      }
    }
  }
}

/********************************
 Cart Sidebar
 ********************************/
function handleCartSidebar(){
  jQuery('.cart-controller').click(function (e) {
    e.stopPropagation();
    jQuery('.cart-sidebar').toggleClass('opened');
    jQuery('html,body').toggleClass('cart-opened');
  });
  
  jQuery('#page').click(function () {
    jQuery('.cart-sidebar').removeClass('opened');
    jQuery('html,body').removeClass('cart-opened');
  });
}

      
/* Handle Menu on Mobile */
function handleMenuMobile(){
  jQuery('#page').click(function () {
    jQuery('.menu-mobile').removeClass('opened');
    jQuery('html,body').removeClass('menu-opened');
  });

  jQuery('[data-toggle=offcanvas]').click(function (e) {
    e.stopPropagation();
    jQuery('.menu-mobile').toggleClass('opened');
    jQuery('html,body').toggleClass('menu-opened');
  });
  
  // add trigger to link
  $('.navbar .nav li > .dropdown-link').hover(function(){
    $(this).addClass('hover');
  }, function(){
    $(this).removeClass('hover');
  });
  $('.is-mobile .navbar .nav li > .dropdown-link > span').click(function() {
    var parent = $(this).parent();
    window.location = parent.attr('href');
  });
  $('.navbar').on('click', '.nav li > .hover > span', function() {
    var parent = $(this).parent();
    window.location = parent.attr('href');
  });
}

// reset product image
function resetProductImg(){
  $('#product-image #main-image').load(function(){
    $('.main-image-bg').hide();
    $('#product-image .main-image div').hide();
  });
}

// search in PC
function handleSearch(){
  $('.search-wrapper2 .search-submit').click(function() {
    var n = $(this).parents('.search-form'),
        t = $('#input-ajax', n);

    if($(this).hasClass('active')){
      n.submit();
    }
    else{
      t.css('visibility', 'visible');

      $(this).addClass('active');
      t.focus();
    }
  });
  
  $('.search-wrapper4 .search-submit').click(function() {
    var n = $(this).parent();

    if(n.hasClass('active')){
      n.removeClass('active');
      $('#header').removeClass('is_search');
    }
    else{
      n.addClass('active');
      $('#header').addClass('is_search');
    }
  });

  $(document).click(function(event) { 
    if(!$(event.target).closest('.search-wrapper2 .search-form').length) {
      if($('.search-wrapper2 .search-form').is(":visible")) {
        $('.search-wrapper2 .search-form #input-ajax').css('visibility', 'hidden');
        $('.search-wrapper2 .search-form .search-submit').removeClass('active');
      }
    }
    
    if(!$(event.target).closest('.search-wrapper4').length) {
      if($('.search-wrapper4 .search-table-wraper').is(":visible")) {
        $('.search-wrapper4').removeClass('active');
        $('#header').removeClass('active');
      }
    }
  })
}
     
// search in mobile
function callbackSearchMobile(){
  var button = $('.is-mobile .is-mobile-search .fa-search');
  var remove = $('.is-mobile .is-mobile-search .fa-times');
  var input = $('.is-mobile .is-mobile-search .input-search');
  var wrapper = $('.is-mobile .is-mobile-search');
  
  button.click(function() {
    wrapper.addClass('on');
    input.focus();
  });
  input.click(function() { 
    return false;
  });
  remove.click(function() {
    wrapper.removeClass('on');
  });
}


// get all products infomation (title and handle)
function ajaxAllProducts(){
  var result = new Array();
  var searchURL = '/collections/all?view=ajax';
  
  $.ajax({
    type: 'GET',
    url: searchURL,
    beforeSend: function () {
      // to do
    },
    success: function (data) {
      
      var elements = $(data).find('.p');
      
      elements.each(function() {
        
        var title = $.trim(this.getAttribute('data-t'));
        var handle = $.trim(this.getAttribute('data-h'));
        
        var item = new Object();
        item.title = title;
        item.handle = handle;
        
        result.push(item);
      });
    },
    dataType: 'html'
  });
  
  return result;
}
// search by ajax
function handleAjaxSearch(){
  var products = ajaxAllProducts();
  
  $( "#input-ajax" ).keyup(function() {
    var that = $(this);
    var keyword = $.trim(that.val().toLowerCase());
    $('#result-ajax').hide();
    
    if(keyword.length >= 3){
      var result = $('#result-ajax .wrapper-ajax').empty();
      
      for (var i = 0; i < products.length; i++) {
        var item = products[i];
        
        var title = item.title;
        var handle = item.handle;
        
        if(title.toLowerCase().indexOf(keyword) > -1){
          
          var markedString = title.replace(new RegExp('(' + keyword + ')', 'gi'), '<span class="marked">$1</span>');
          
          var template = '<li><a href="/products/'+ handle +'">'+ markedString +'</a></li>';
          result.append(template);
        }
      }
      
      if($('#result-ajax .wrapper-ajax li').length){
        $('#result-ajax').show();
      }
    }
    else{
      $('#result-ajax').hide();
    }
  });
  
  $(this).click(function(e) {
    if(!($(e.target).parent('#result-ajax').length > 0)) {
      $('#result-ajax').hide();
    }
  });
}
     
// handle countdown
function handleCountdown(){
  $('.count_holder_big').each(function() {        
    var tip = $(this).find('.count_holder_small');
    
    $(this).hover(
      function() { tip.addClass('hover').appendTo('body'); },
      function() { tip.removeClass('hover').appendTo(this); }
    ).mousemove(function(e) {
      var x = e.pageX + 60,
          y = e.pageY - 50,
          w = tip.width(),
          h = tip.height(),
          dx = $(window).width() - (x + w),
          dy = $(window).height() - (y + h);
      
      if ( dx < 50 ) x = e.pageX - w - 60;
      //if ( dy < 50 ) y = e.pageY - h - 130;
      
      tip.css({ left: x, top: y });
    });         
  });
}   
     
// handle smooth scroll
function handleSmoothScroll() {
  $("body").on("click", ".smoothscroll", function(e) {
    e.preventDefault();
    var t = $(this).attr("href");
    if($(t).find('.accordion-toggle').hasClass('collapsed')){
      $(t).find('.accordion-toggle').trigger('click');
    }
    setTimeout(function() {$("html,body").animate({
      scrollTop: $(t).offset().top - 100
    }, 800, "swing")}, 300);
  })
}
     
     
// Notification for IE7 users
function notifyIE7Users(){
  if( $('html').hasClass('ie8') || $('html').hasClass('ie7') ){
    
    
    var notify = '<h1>Unsupported Browser</h1>';
    $('body').html(notify).show();
    
  }
}


function socialSharing() {
  // General selectors
  var $buttons = $('.social-sharing'),
      $shareLinks = $buttons.find('a.share'),
      permalink = $buttons.attr('data-permalink');

  // Share button selectors
  var $fbLink = $('.share-facebook'),
      $twitLink = $('.share-twitter'),
      $pinLink = $('.share-pinterest'),
      $googleLink = $('.share-google');

  if ( $fbLink.length ) {
    $.getJSON('https://graph.facebook.com/?id=' + permalink + '&callback=?', function(data) {
      if (data.shares) {
        $fbLink.find('.share-count').text(data.shares).addClass('is-loaded');
      } else {
        $fbLink.find('.share-count').remove();
      }
    });
  };

  if ( $twitLink.length ) {
    $.getJSON('https://cdn.api.twitter.com/1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
      if (data.count > 0) {
        $twitLink.find('.share-count').text(data.count).addClass('is-loaded');
      } else {
        $twitLink.find('.share-count').remove();
      }
    });
  };

  if ( $pinLink.length ) {
    $.getJSON('https://api.pinterest.com/v1/urls/count.json?url=' + permalink + '&callback=?', function(data) {
      if (data.count > 0) {
        $pinLink.find('.share-count').text(data.count).addClass('is-loaded');
      } else {
        $pinLink.find('.share-count').remove();
      }
    });
  };

  if ( $googleLink.length ) {
    // Can't currently get Google+ count with JS, so just pretend it loaded
    $googleLink.find('.share-count').addClass('is-loaded');
  }

  // Share popups
  $shareLinks.on('click', function(e) {
    e.preventDefault();
    var el = $(this),
        popup = el.attr('class').replace('-','_'),
        link = el.attr('href'),
        w = 700,
        h = 400;

    // Set popup sizes
    switch (popup) {
      case 'share-twitter':
        h = 300;
        break;
      case 'share-fancy':
        w = 480;
        h = 720;
        break;
      case 'share-google':
        w = 500;
        break;
    }

    window.open(link, popup, 'width=' + w + ', height=' + h);
  });
}

function detectOptions(){
  if( getWidthBrowser() < 992 ){
    if(jQuery('#product-header-first').is(':empty')){
      jQuery("#product-header").detach().appendTo('#product-header-first');
    }
  }
  else{
    if(!jQuery('#product-header-first').is(':empty')){
      jQuery("#product-header").detach().appendTo('#product-header-last');
    }
  }
}
     
function initDocumentReady(){
  
  detectOptions();
  
  callbackImagesLoaded();
  
  notifyIE7Users();
  
  
  handleAjaxSearch();
  

  handleTooltip();
  
  handleCountdown();
  
  handleTabs();
  
  handleSearch();
  
  callbackSearchMobile();
  
  goToPage();
  
  handleScreenshotPreview();
  
  handleMenuMobile();
  
  handleCartSidebar();
  
  handleDropdown();
  
  handleImageThumbs();
  
  resetProductImg();
  
  socialSharing();
  
  $('.noclose').click(function (e) {
    e.stopPropagation();
  });
  
  handleSlideshow();
  
  handleMap();
  
  if(touch == false){
    if($('#home-slider').length){
      imagesLoaded('#home-slider', function() {
        handleDataAnimate();
      });
    }
    else{
      handleDataAnimate();
    }
  }
  
  handleScrollToTop();
  
  handleSmoothScroll();
  
  alwaysRefreshZoom();
  
  handleGridList();
  
  if($('.product-fancybox-buttons').length){
    $('.product-fancybox-buttons').fancybox({
      closeBtn  : false,
      helpers : {
        buttons	: {}
      }
    });
  }
}
     
function callbackImagesLoaded(){
  
  /* # Product Thumbs */
  if($('.product-image-thumb').length){      
      
      $(".product-image-thumb").owlCarousel({
        navigation : true,
        pagination: false,
        mouseDrag: false,
        items: 5,
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [991,4],
        itemsTablet: [768,3],
        itemsMobile : [479,3],
        scrollPerPage: true,
        navigationText: ['<span class="btn mini"><i class="fa fa-angle-left"></i></span>', '<span class="btn mini"><i class="fa fa-angle-right"></i></span>']
      });
      
  }
  
  /* # Related Products */
  if($('#product-related').length){    
    
    $("#product-related").owlCarousel({
      navigation : true,
      pagination: false,
      mouseDrag: false,
      items: 4,
      itemsDesktop : [1199,4],
      itemsDesktopSmall : [991,4],
      itemsTablet: [768,3],
      itemsMobile : [479,2],
      scrollPerPage: true,
      navigationText: ['<span class="btn mini"><i class="fa fa-angle-left"></i></span>', '<span class="btn mini"><i class="fa fa-angle-right"></i></span>'],
      beforeMove: function(elem) {
        if(touch == false){
          var that = $(elem);
          var items = that.find('.animated');
          items.removeClass('animated').unbind('appear');
        }
      }
    });
    
  }
       
       
  /* # Featured Collection */  
  $(".featured-collections-child").owlCarousel({
    navigation : true,
    pagination: false,
    mouseDrag: false,
    lazyLoad : true,
    items: 2,
    itemsDesktop : [1199,2],
    itemsDesktopSmall : [991,3],
    itemsTablet: [768,3],
    itemsTabletSmall: [767,2],
    itemsMobile : [479,1],
    scrollPerPage: true,
    navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>'],
    beforeMove: function(elem) {
      if(touch == false){
        var that = $(elem);
        var items = that.find('.animated');
        items.removeClass('animated').unbind('appear');
      }
    }
  });
       
  
  /* # Featured Products */
  if($('#featured-products').length){
    
  }
      
      
  /* # Special Offers */
  if($('#special-offers').length){
      $("#special-offers").owlCarousel({
        navigation : true,
        pagination: false,
        mouseDrag: false,
        items: 3,
        itemsDesktop : [1199,3],
        itemsDesktopSmall : [991,3],
        itemsTablet: [768,3],
        itemsTabletSmall: [767,2],
        itemsMobile : [479,1],
        scrollPerPage: false,
		navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>'],
        beforeMove: function(elem) {
          if(touch == false){
            var that = $(elem);
            var items = that.find('.animated');
            items.removeClass('animated').unbind('appear');
          }
        }
       });
  }
  
  
  /* # Our Partners */
  if($('#our-partner').length){
      $("#our-partner").owlCarousel({
        navigation : true,
        pagination: false,
        mouseDrag: false,
        items: 5,
        itemsDesktop : [1199,5],
        itemsDesktopSmall : [991,4],
        itemsTablet: [768,3],
        itemsTabletSmall: [767,3],
        itemsMobile : [479,1],
        scrollPerPage: false,
		navigationText: ['<span class="btn medium"><i class="fa fa-angle-left"></i></span>', '<span class="btn medium"><i class="fa fa-angle-right"></i></span>'],
        beforeMove: function(elem) {
          if(touch == false){
            var that = $(elem);
            var items = that.find('.animated');
            items.removeClass('animated').unbind('appear');
          }
        }
       });
  }
  
  /* # Latest Posts */
  if($('#latest-posts').length){
    $('#latest-posts').on('hover', '.latest-post', function(){
      $('#latest-posts .latest-post').removeClass('active');
      $(this).addClass('active');
    });
    
  }
}

$(window).resize(function() {
  
  
  handleResetMenuScroll();
  
  
  detectOptions();
  mockupCaptionSlider();
  mockupCaptionVideo();
});
      
$(window).scroll(function() {

  
  handleMenuScroll();
  
});

jQuery(document).ready(function($) {
  
  /* DETECT PLATFORM */
  if (isMobile()) {
    touch = true;
    $('body').addClass('touch');
    clickEv = 'touchstart';
  }
  else{
    $('body').addClass('notouch');
    if (navigator.appVersion.indexOf("Mac")!=-1){
      if (navigator.userAgent.indexOf("Safari") > -1){
      $('body').addClass('macos');
      }
    }
  };
  
  initMegaMenu();
  
  mockupCaptionVideo();
  
  initDocumentReady();
  
  
});

function initMegaMenu(){
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('full_width');
  
  
  
  
  
  
  
  var menu_bg_url = 'url(//cdn.shopify.com/s/files/1/2673/2824/t/3/assets/mega_menu_bg1.jpg?v=19349921614478334821514298455)';
  
  jQuery(nav_name).addClass('has_bg').css({'background-image':menu_bg_url, 'background-position':'100% 100%', 'background-repeat':'no-repeat'});
  
  
  
  
  
  
  var menu_height = 300;
  
  jQuery(nav_name).css({'min-height':menu_height + 'px'});
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var nav_name = '.nav_';
  
  
  
  
  
  
  jQuery(nav_name).parent().addClass('mega_menu').addClass('custom_width');
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  var fixMegaMenuPosition = function() {
    jQuery('.mega_menu.custom_width').each(function(index, value) {
      var custom_menu = jQuery(this),
          col_width = 200, //width of a column
          maxcol = 3,      //max columns in a row
          col = 1;         //min num of column
      
      var nchild = custom_menu.find('>ul.dropdown-menu').children('li.dropdown-parent-submenu').length;

      if ( Math.ceil(nchild / maxcol) > 1 ) {
        col = 3;
      } else {
        col = nchild;
      }
      
      var cal_width = col_width * col + col*15 +10;
      
      custom_menu.find('>ul.dropdown-menu').css({'width':cal_width + 'px'});
    });
  }
  fixMegaMenuPosition();
  
  var fixMegaMenuPositionFullWidth = function() {
    jQuery('.mega_menu.full_width').each(function(index, value) {
      var _container_offet = jQuery('.navigation_wrapper').offset();
      var _cur_offset = jQuery(value).offset();
      var _margin_left = _cur_offset.left - _container_offet.left;
      _margin_left = _margin_left - (jQuery('.navigation_wrapper').outerWidth() - jQuery('.navigation_wrapper').width()) / 2;
      jQuery(value).find('>ul.dropdown-menu').css('width', jQuery('.navigation_wrapper').width()).css('left', '-' + _margin_left + 'px');
    });
  }
  
  _onresize( fixMegaMenuPositionFullWidth );
  fixMegaMenuPositionFullWidth();
  
  jQuery('.mega_menu.full_width').on('hover', function() {
    var _container_offet = jQuery('.navigation_wrapper').offset();
    var _cur_offset = jQuery(this).offset();
    var _margin_left = _cur_offset.left - _container_offet.left;
    _margin_left = _margin_left - (jQuery('.navigation_wrapper').outerWidth() - jQuery('.navigation_wrapper').width()) / 2;
    jQuery(this).find('>ul.dropdown-menu').css('width', jQuery('.navigation_wrapper').width()).css('left', '-' + _margin_left + 'px');
  });
}

function _onresize( f ) {
  jQuery(window).on( 'resize', f );
}